{
  "home-page-title": "Webapp",
  "clear-btn": "Clear",
  "close-btn": "Close",
  "cancel-btn": "Cancel",
  "delete-btn": "Delete",
  "share-btn": "Share",
  "download-btn": "Download",
  "favorite-btn": "Favorite",
  "ok-btn": "OK",
  "done-btn": "Done",
  "yes-btn": "Yes",
  "no-btn": "No",
  "create-story-btn": "Create a Story",
  "submit-registration-btn": "Open Album",
  "save-btn": "Save",
  "apply-btn": "Apply",
  "checkout-btn": "Checkout",
  "info-title": "Info",
  "registration-page-title": "Register",
  "contact-completion-page-title": "Contact completion",
  "registration-name-placeholder": "Your name",
  "registration-email-placeholder": "Your email",
  "registration-email-or-phone-placeholder": "Your email or US phone number",
  "registration-country-code-default": "US +1",
  "registration-accept-label": "I Accept",
  "registration-privacy-link": "Terms and Conditions",
  "registration-sms-agreement-label": "I agree to receive notification messages from Storibox at the phone number provided above. I understand I will receive SMS messages containing updates and links to my images. Data and messaging rates may apply. Reply STOP to opt out.",
  "registration-submit-loading-label": "Loading...",
  "registration-create-attendee-error-message": "Failed to create an attendee. Please try again later.",
  "registration-create-attendee-email-confirmation-error-message": "Failed to create an attendee. Please try again later. Check please your email is confirmed.",
  "registration-invalid-us-phone-message": "Please use only a US phone number like this: +11234567890.",
  "registration-us-phone-length-message": "Phone number should be 10 digits after country code (+1), but yours is {{length}}.",
  "registration-contact-required-message": "Email or phone number is required.",
  "registration-invalid-email-message": "Please enter valid E-mail address.",
  "registration-email-required-message": "Email is required.",
  "registration-sms-consent-required-message": "Your consent to the SMS agreement is required. Otherwise, you cannot register for the service.",
  "registration-privacy-consent-required-message": "Your consent to the Terms and Conditions is required. Otherwise, you cannot register for the service.",
  "selfies-empty-title": "Missing a Selfie!",
  "selfies-empty-message": "Please add a good portrait picture\nfor all people in your party to find\nyour images quickly.",
  "selfies-add-btn": "+ Add",
  "purchase-btn": "Purchase",
  "home-select-all-btn": "Select All",
  "home-selected-count-label_one": "1 item selected",
  "home-selected-count-label_other": "{{count}} items selected",
  "home-empty-album-message": "The album is empty",
  "home-empty-album-subtext-message": "There are no images in your<br>album yet.",
  "home-qr-modal-title": "My Album Code",
  "home-qr-modal-message": "Scan this QR at the kiosk to access your photos, or present it to our roaming photographers when asked.",
  "home-qr-scanner-message": "Scan the QR code on images or videos of you from the photo viewing kiosk to link your media with this app.",
  "home-qr-camera-access-message": "🎥 Please ensure that you have enabled the camera access to scan QR code.",
  "home-qr-scanner-show-my-qr-btn": "Show my QR",
  "menu-registered-selfies": "Registered Faces",
  "menu-qr-scanner": "QR Scanner",
  "menu-album-code": "My Album Code",
  "menu-privacy": "Terms and Conditions",
  "menu-faq": "FAQ",
  "menu-support": "Support",
  "home-step-label": "Step {{amount}} of {{total}}",
  "home-select-up-to-images-title_one": "Select up to 1 image",
  "home-select-up-to-images-title_other": "Select up to {{count}} images",
  "home-select-as-many-images-title": "Select as many images as you want",
  "home-select-target-label": "for \"{{name}}\"",
  "home-no-albums-found-message": "No albums found.",
  "home-event-config-missing-message": "This event is not configured for the web app.",
  "home-create-story-waiting-message": "Your story is being created. Please check your album again in a few minutes.",
  "home-ugc-tooltip-message": "You can upload photos from your camera roll and have them printed at the kiosk!",
  "home-face-reco-tooltip-message": "Please upload a selfie, or a good portrait picture of everyone in your party so we can find your images!",
  "home-select-to-share-or-download-message": "Select at least one image to share or download.",
  "home-select-without-watermark-message": "Only images without watermarks can be shared or downloaded.",
  "home-select-to-delete-message": "Select at least one image to delete.",
  "home-share-download-locked-message": "Some of your selected photos are locked. To share or download them, please purchase a Digital Pass.",
  "home-face-register-help-message": "Please make sure that your face is evenly illuminated and fully visible. Maintain a neutral expression.",
  "home-no-selfies-suggestion-message": "Oops, looks like you have not registered your selfie. Take a selfie now to receive your priceless memories.",
  "home-no-face-mask-message": "NO FACE MASKS",
  "home-selfie-maybe-later-btn": "Maybe Later",
  "home-delete-stock-warning-message": "You have selected an event stock image to delete. It cannot be deleted from your album and will be skipped.",
  "home-delete-confirm-message": "Deleting images from your album cannot be undone. Are you sure you want to proceed?",
  "home-delete-reason-not-wanted": "I don't want those images in my album",
  "home-delete-reason-not-mine": "Those are not my images",
  "home-delete-confirm-btn": "Yes, delete",
  "home-upload-unsupported-format-message": "Unsupported image format. Please use a different image file.",
  "home-upload-generic-error-message": "An error occurred while uploading your photo. Please try again or contact support.",
  "home-upload-limit-reached-message": "You have reached your photo upload limit. Please contact support if you need to upload more photos.",
  "home-upload-processing-error-message": "An error occurred while processing your photo. Please try again or contact support.",
  "home-upload-processing-message": "Your photos will be in your album in a minute!",
  "home-upload-photo-message": "Upload a photo from your camera roll for printing!",
  "home-turn-me-into-tag-upload-message": "Take a selfie or upload a portrait from your camera roll.",
  "home-turn-me-into-tag-processing-message": "We are working on transforming your image! Refresh this page in a minute or so.",
  "home-download-waiting-message": "Downloading files.<br/>Please be patient.",
  "download-selection-too-large-message": "Sorry - this selection is too large to download at once. Please choose fewer photos, or download them one at a time.",
  "home-download-360-message": "This is interactive content, best viewed within this album. You can still download the raw file to share online or view later in apps that recognize 360 spherical format.",
  "home-scanned-image-confirm-message": "Yay, great picture! For security please confirm. Is this your image?",
  "home-media-share-title": "Media",
  "webapp-share-title": "Check out my Storibox album!",
  "webapp-ogp-title": "My Storibox Album",
  "webapp-ogp-description": "View and share photos and videos from my Storibox album.",
  "home-share-files-unsupported-message": "Your browser does not support sharing files. Please use a different browser or download the files directly.",
  "home-share-files-waiting-message": "Downloading files for sharing.<br/>Please be patient.",
  "title-select-a-combo": "Choose a Combo",
  "title-select-a-la-carte": "A La Carte",
  "title-shopping-cart": "Shopping Cart",
  "checkout-change-image-btn": "Change Image",
  "checkout-empty-cart-message": "Cart is empty",
  "checkout-add-product-btn": "Add product",
  "checkout-subtotal-label": "Subtotal:",
  "checkout-taxes-label": "Taxes (0%)",
  "checkout-total-label": "Total Amount:",
  "checkout-promo-code-placeholder": "promotion code",
  "checkout-add-on-btn": "+ Add On",
  "checkout-invalid-promo-code-message": "Invalid or not applicable promotion code!",
  "checkout-discount-label": "Discount: {{title}}",
  "checkout-delete-restriction-message": "You must keep at least one package in your shopping cart if you wish to purchase add-ons. If you need to change the package, please first remove all add-ons from your shopping cart.",
  "checkout-digital-package-upsell-message": "Would you like to add a<br>digital package to your<br>shopping cart and gain access<br>to all your digitals?",
  "photo-plus-maybe-later-btn": "Maybe Later",
  "photo-plus-upgrade-btn": "Yes, Upgrade",
  "checkout-digital-package-duplicate-message": "You already have a digital access package in your shopping cart.<br>A new package can not be added until you remove or purchase the current one.",
  "title-change-image": "Select photo",
  "title-select-images": "Select photos",
  "title-registered-selfies": "Registered Faces",
  "title-privacy": "Terms and Conditions",
  "title-faq": "FAQ",
  "title-shoot": "Shoot",
  "title-remote-shoot": "Remote Shoot",
  "title-thank-you": "Thank you",
  "shoot-again-btn": "Shoot again",
  "select-image-done-btn-name_final": "Done",
  "select-image-done-btn-name_incomplete": "Next",
  "select-image-done-btn-counter_finite": "({{amount}}/{{total}})",
  "select-image-done-btn-counter_infinite": "({{amount}})",
  "remote-shoot-btn": "Shoot",
  "remote-shoot-start-message": "Look at the camera and click 'Shoot' when ready",
  "remote-shoot-countdown-message": "Look at the lights",
  "remote-shoot-rendering-message": "Your content is being created. Check your album in a few seconds for an awesome new video!",
  "selfie-upload-window-expired-message": "The time window for finding your photos using a selfie has expired for this event."
}